import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import type { NodeSpec } from './NodeSpec';

export const flowErrorUiNodeSpec: NodeSpec<NodeCfg<'flowError'>> = {
    requiredSockets: 'all',
    cfg: () => ({ id: getUID(), kind: 'flowError', disabled: false }),
    controls: () => ({}),
    inputs: () => ({}),
    kindLabel: 'Flow Error',
    nodeCategory: 'events',
    outputs: () => ({
        trigger: { socket: 'event', label: 'Trigger' },
        error: { socket: 'string', label: 'Error' },
    }),
    validator: () => true,
};
